<template>
  <TemplateBase>
    <main class="relative z-0 col-span-full row-start-2" :class="{ 'xl:row-start-1': image }">
      <!-- Header -->
      <MoleculeHeaderOverview class="mb-8 sm:mb-12 md:mb-8 lg:mb-16" :title="title" :introduction="introduction" :image="image" :class="{ 'mt-16 lg:mt-20': !image }" />

      <pre class="hidden">{{ JSON.stringify(error, null, 2) }}</pre>

      <section v-if="description" class="container relative grid grid-cols-12 mx-auto px-4 mb-16 xl:mb-24">
        <!-- Div with responsive page layout in columns -->
        <div class="relative z-40 col-span-full 2xl:col-end-10 2xl:col-start-4 lg:col-end-12 lg:col-start-2 xl:col-end-11 xl:col-start-3">
          <!-- White sheet with page content -->
          <div class="padding-page-content relative bg-white rounded-xl">
            <!-- Page body text -->
            <div class="prose prose--app max-w-none overflow-auto" v-html="description" />
          </div>
        </div>
      </section>
    </main>
  </TemplateBase>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  introduction?: string
  description?: string
  image?: Record<string, any> // Assuming image is an object; specify exact type if known
}

defineProps<Props>()

const error = useError()
</script>
